module.exports = __webpack_public_path__ + "img/20-1.492c1bb4.png";